import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Thomas Hunsaker
 * id 741B300C-06EF-459D-BB3E-95DB8E21194E
 * name bow-tie
 * version: 1.7.12
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bow-tie.svg
 * tags
 * - Clothing 
 */
export const BowTieIcon = createSvgIcon(<><path d="M15,14L21,17V7L15,10V14M9,14L3,17V7L9,10V14M10,10H14V14H10V10Z" /></>, 'BowTieIcon');
export default BowTieIcon